export default __webpack_public_path__ + "static/media/sluch-slabikovani.17daa554.svg";